// Author: Suhail Jamaldeen 
// Date: 26.10.2023
//Version: 01
//Logic: Add and Edit Grn

import React, { useEffect, useState } from "react";

import {
  Button,
  TextField,
  CircularProgress,
  InputAdornment,
  Box,
  IconButton,
  RadioGroup,
  Radio,

} from "@mui/material";
import { Formik, Form, FieldArray } from "formik";
import * as yup from "yup";
import Dialog from "../../MUI_components/Dialog-Box/dialog";
import Stepper from "../../MUI_components/stepper";
import { useDispatch, useSelector } from "react-redux";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import Table from "./addingStockTable";
import CloseIcon from "@mui/icons-material/Close";
import GrnService from "../../../Service/Stock/grn.service";
import SupplierService from "../../../Service/Suppliers/supplier.service";
import ItemMasterService from "../../../Service/Item-master/itemMaster.service";

import Loading from "../../MUI_components/loading";
import FromControl from "../../MUI_components/FormControl/fomikFormControl";

import { NumFormat } from "../../MUI_components/currencyFormat";
import Selects from "../../MUI_components/AutoComplete/selects";
import AsynchronousDropdown from "../../MUI_components/AutoComplete/asynchronousAutoComplete";
import AsyncAutoCompleteEnter from "../../MUI_components/AutoComplete/asynchronousAutoCompleteEnter";

import FormControlLabel from "@mui/material/FormControlLabel";
import { findAllByDisplayValue } from "@testing-library/react";
import { SETTING } from "Components/Constants/Setting";
import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import { DROPDOWN_OPTION } from "Components/Constants/DropDown";
import AddItemMaster from "Components/Stock/Item_Master/addItemMaster";
import { AddCircle } from "@mui/icons-material";
import BarcodePreview from "./Barcode/BarcodePriview";
import BasicDialog from "Components/MUI_components/Dialog-Box/basicDialog";

const AddGRN = ({ setOpen, code, setSubmitted }) => {
  const stockLocations = useSelector((state) => state.location);
  const dispatch = useDispatch();
  const defaultLocationSelected = useSelector((state) => state.defaultLocation);


  const [isLoaded, setIsLoaded] = useState(false);
  const [isUpdatePrice, setIsUpdatePrice] = useState(false);

  const initStockValue = {
    locationCode: "",
    quantity: "",
    discountAmount: 0,   //line discount amount
    discountPercentage: 0,   //line discountPercentage
    discountTotal: "",      // total linediscount
    totalAmount: 0,     //after total linediscount 
    subTotalAmount: 0,    //before total linediscount
    itemMaster: "",
    costPrice: "",
    retailPrice: "",
    wholesalePrice: "",
    expiryDate: "",
    warrantyPeriods: "",
    batch: ""
  };

  const initGrnValue = {

    discountAmount: "", // Entire GRN discount Amount 
    discountPercentage: "",// Entire GRN discount Percentage 
    grnDiscount: "",//discountAmount + discountPercentage
    discountTotal: "", // Line Discount + GRN Discount
    totalAmount: 0,
    subTotalAmount: 0,

  };

  const [grnValue, setGrnValue] = useState(initGrnValue);
  const [stock, setStock] = useState(initStockValue);
  // console.log('stock', stock);
  
  const today = new Date().toISOString().split("T")[0];

  const [initValue, setInitValue] = useState({});
  const [purchaseReturn, setPurchaseReturn] = useState(null);//This used to store puchase return details fir the perticular grn
  const [openn, setOpenn] = useState(false);
  const [formSubmitted, setFromSubmitted] = useState(false);
  const [openSingleBarcode, setOpenSingleBarcode] = useState(false);
  const [openMultipleBarcode, setOpenMultipleBarcode] = useState(false);
  const [barcodeLoading, setBarcodeLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [labelSize, setLabelSize] = useState("4by1");

  // console.log('labelSize', labelSize);
  


   const handleClickOpen = () => {
    setOpenn(true);
  };

 const handleMultipleBarcodeGenerate = (value) => {
  const histories = value?.stockHistories || [];

  // Calculate total quantity safely
  const totalQty = histories.reduce((sum, history) => {
    const qty = Number(history?.quantity) || 0;
    return sum + qty;
  }, 0);

  // Limit check FIRST (important)
  if (totalQty > 300) {
    dispatch(
      openSnackbar(
        true,
        "error",
        "Cannot generate more than 300 barcodes at once."
      )
    );
    return;
  }

  // Generate duplicated product list ONLY after validation
  const allProducts = histories.flatMap((history) => {
    const qty = Number(history?.quantity) || 0;
    return Array.from({ length: qty }, () => ({ ...history }));
  });

  setProducts(allProducts);
  setOpenMultipleBarcode(true);
};


  const handleSingleBarcodeGenerate = (stock) => {
    const qty = Number(stock.quantity) || 0;

    if (qty > 100) {
      dispatch(
        openSnackbar( true, "error", "Cannot generate more than 100 barcodes at once.")
      );
      return;
    }

    const duplicated = Array.from({ length: qty }, () => stock);

    setProducts(duplicated);
    setOpenSingleBarcode(true);
};


  useEffect(() => {
    const getGrn = async () => {
      if (code) { //if code there only can edit, otherwise go to else and insert it
        try {
          let response = await GrnService.get(code);
          // converting NULL value into Empty string
          const grnDate = new Date(response.grnDate)
            .toISOString()
            .split("T")[0];
          response = JSON.parse(
            JSON.stringify(response).replace(/:null/gi, ':""')
          );
          setInitValue({ ...response, grnDate: grnDate });
          setGrnValue(response);
          setPurchaseReturn(response.purchaseReturn);
        } catch (e) {
          dispatch(openSnackbar(true, "error", e));
        }
      } else {
        setInitValue({
          supplier: null,
          invoiceCode: "",
          remarks: "",
          invoiceDate: today,
          grnDate: today,
          totalAmount: 0,
          discountAmount: 0,
          discountPercentage: 0,
          subTotalAmount: 0,
          isActive: true,
          isLocked: true,
          updatePrice: isUpdatePrice,
          stockHistories: [],

        });
      }
      setIsLoaded(true);
    };
    getGrn();
  }, [code, dispatch, today]);

  const [activeStep, setActiveStep] = React.useState(0);

  // validation Schema for first step
  const Validation = yup.object({
    supplier: yup.object().required("Supplier is Required").nullable(),
    invoiceCode: yup.string().required("Invoice Number is Required"),
    costPrice: yup.string().min(1).max(7),
    wholesalePrice: yup.string().min(1).max(7),
    retailPrice: yup.string().min(1).max(7),
  });

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };
  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };
  const getSteps = [    // for handleNext function
    "Goods received note",
    "Received Items"];

  const handleStockDataChange = (e) => {
    const { name } = e.target;
    const { value } = e.target;

    setStock({
      ...stock,
      [name]: value,

    });
  };



  const handleSubmit = async (values) => {
    try {
      const subTotalAmount = values.stockHistories.map(({ totalAmount }) => parseInt(totalAmount))
        .reduce((sum, i) => sum + i, 0);

      // Sajana Check
      let disAmt = grnValue.discountAmount;
      let disPer = grnValue.discountPercentage;
      let subTotal = grnValue.totalAmount;

      if (code)
        await GrnService.edit({
          ...values,
          subTotalAmount: subTotalAmount,
          discountAmount: grnValue.discountAmount,
          discountPercentage: grnValue.discountPercentage,
          grnDiscount: (grnValue.discountPercentage / 100 * subTotalAmount) + parseFloat(disAmt ? disAmt : 0),
          totalAmount: subTotalAmount - ((grnValue.discountPercentage / 100 * subTotalAmount) + parseFloat(disAmt ? disAmt : 0)),
          paidAmount: 0
        }, code);

      else await GrnService.create({
        ...values,
        subTotalAmount: subTotalAmount,
        discountAmount: grnValue.discountAmount,
        discountPercentage: grnValue.discountPercentage,
        grnDiscount: (grnValue.discountPercentage / 100 * subTotalAmount) + parseFloat(disAmt ? disAmt : 0),
        totalAmount: subTotalAmount - ((grnValue.discountPercentage / 100 * subTotalAmount) + parseFloat(disAmt ? disAmt : 0)),
        paidAmount: 0
      });
      setSubmitted((prev) => !prev);
      setOpen(false);
      dispatch(
        openSnackbar(
          true,
          "success",
          `GRN ${code ? "updated" : "created"} successfully`
        )
      );
    } catch (e) {
      dispatch(openSnackbar(true, "error", e));
    }
  };

  return (
    <>
      {isLoaded ? (
        <Formik
          initialValues={initValue}
          validationSchema={Validation}
          onSubmit={async (values) => {
            if (activeStep === getSteps.length - 1) {
              await handleSubmit(values);
              // console.log('vales', values);
              
            } else handleNext();
          }}
        >
          {(props) => (
            <Form autoComplete="off"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault(); // Prevent form submission on Enter key
              }
            }}
            >
              <Stepper
                getSteps={getSteps}
                StepContent={getStepContent}
                activeStep={activeStep}
                values={props.values}
                setFieldValue={props.setFieldValue}
              />
              <div className="row space-between mb">
                <Button disabled={activeStep === 0} onClick={handleBack}>
                  Back
                </Button>

                <div style={{ display: "flex" }}>


                  <FromControl
                    disabled={activeStep === 0}
                    control="switch"
                    name="updatePrice"
                    onChange={(selected) => {
                      //  selected?setIsUpdatePrice(true):setIsUpdatePrice(false)
                      setIsUpdatePrice(true)
                    }}
                    label="Update Price"
                  />
                  <Button
                    disabled={
                      props.isSubmitting ||
                        (activeStep === getSteps.length - 1 &&
                          props.values.stockHistories.length === 0)
                        ? true
                        : false
                    }
                    startIcon={
                      props.isSubmitting && (
                        <CircularProgress color="inherit" size={20} />
                      )
                    }
                    variant="contained"
                    type="submit"
                    color="secondary"
                  >
                    {activeStep === getSteps.length - 1 ? "Complete" : "Next"}
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <Loading />
      )}
    </>
  );

  function getStepContent(step, values, setFieldValue) {

    switch (step) {
      case 0:
        return (
          <>

            <div className="row">
              <div className="col-3">
                <FromControl
                  disabled={purchaseReturn?.length > 0}
                  control="asynchronousAutoComplete"
                  label="Supplier *"
                  name="supplier"
                  Service={SupplierService}
                  getOptionLabel={(option) =>
                    option.name +
                    " - " +
                    option.phone1 +
                    " - " +
                    option.code
                  }
                />
              </div>
              <div className="col-3">
                <FromControl
                  control="input"
                  label="Invoice Number *"
                  name="invoiceCode"
                />
              </div>
              <div className="col-3 ">
                <FromControl
                  control="input"
                  type="date"
                  label="Invoice Date"
                  name="invoiceDate"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    max: today,
                  }}
                />
              </div>

              <div className="col-3 ">
                <FromControl
                  control="input"
                  type="date"
                  label="GRN Date"
                  name="grnDate"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    max: today,
                  }}
                  disabled
                />
              </div>
              <div className="col-12">
                <FromControl
                  control="input"
                  label="Remarks"
                  name="remarks"
                />
              </div>
            </div>


            {purchaseReturn?.length > 0 &&
              < div className="row">
                <div className="col-12">
                  Purchase Retuns: {purchaseReturn.map((row, i) => (
                    < div >{row.code}</div>
                  ))}
                </div>
              </div>
            }
          </>
        );
      case 1:
        return (
          <>
            <FieldArray name="stockHistories">

              {(props) => {
                const { push, remove, form } = props;
                const { setFieldValue, values } = props.form;
                const { stockHistories } = form.values;
                return (
                  <>     
                    <div className="row">
                      <div className="col-1">
                        <IconButton color="primary" onClick={handleClickOpen}>
                          <AddCircle sx={{ fontSize: 40 }}/>
                              </IconButton>
                                  <Dialog
                                    maxWidth={"md"}
                                    open={openn}
                                    setOpen={setOpenn}
                                    title={`Add Item Master`}
                                      >
                                    <AddItemMaster
                                      setSubmitted={setFromSubmitted}
                                      setSubmittedd={setStock}
                                      stock={stock}
                                      setOpen={setOpenn}
                                      // {...rest}
                                    />
                                   </Dialog>

                    </div>
                    <div className="col-11">
                      <FormControl
                           control="autoComplete"
                           name="searchBy"
                           label="Search By"
                           getOptionLabel={(option) =>
                             option.name
                           }
                           options={DROPDOWN_OPTION.SEARCH_BY}
                         />
                      </div>
                      <div className="col-10">
                        <AsyncAutoCompleteEnter
                            inputProps={{
                              label: "Item Master",
                            }}
                            disabled={stock.editIndex || stock.editIndex === 0}
                              filterOptions={(options, { inputValue }) => {
                              const keywords = inputValue.split(" ").filter(Boolean); // Split input value into keywords and filter out empty strings
                            
                              if (keywords.length === 0) {
                                return options; // Return all options if no keywords are provided
                              }
                            
                              return options.filter((option) => {
                                const itemName = option.name?.toLowerCase() || '';
                                const itemDescription = option?.description?.toLowerCase() || '';
                                const itemBarcode = option.barcode.toLowerCase()  || '';

                                return keywords.every((keyword) => {
                                  const lowerCaseKeyword = keyword.toLowerCase();
                                  return keywords.every((keyword) => {
                                    const lowerCaseKeyword = keyword.toLowerCase();
                                    return itemName.includes(lowerCaseKeyword) || 
                                    itemDescription.includes(lowerCaseKeyword) ||  
                                    itemBarcode.includes(lowerCaseKeyword);
                                  });
                                });
                              });
                            }}
                            name="itemMaster"
                            stockValidate = {false}
                            searchBy={values.searchBy}
                            Service={ItemMasterService.posSearchWithotStock}
                            value={stock?.itemMaster}
                            getOptionLabel={(option) =>
                              option.name +
                              " - " +
                              option.barcode
                            }
                            renderOption={(props, option) => (
                              <Box {...props}>
                                  <div>
                                  { option.name +
                                    " | " +
                                    option.barcode +
                                    " | " +
                                    option.description}
                                  </div>
                              </Box>
                            )}
                            onChange={(e, newValue) =>
                              newValue === null
                                ? setStock({
                                  ...stock,
                                  itemMaster: null,
                                  costPrice: "",
                                  retailPrice: "",
                                  wholesalePrice: "",
                                })
                                : setStock({
                                  ...stock,
                                  itemMaster: newValue,
                                  costPrice: newValue.costPrice,
                                  retailPrice: newValue.retailPrice,
                                  wholesalePrice: newValue.wholesalePrice,

                                })
                            }
                          />
                      </div>
                     
                      <div className="col-2">
                        <NumFormat
                          name="quantity"
                          label="Quantity*"
                          control="currency"
                          value={stock.quantity}
                          onChange={handleStockDataChange}
                          variant="outlined"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <FormControl
                          name="costPrice"
                          label="Cost Price*"
                          control="currency"
                          onValueChange={(val) =>
                            setStock({
                              ...stock,
                              costPrice: val.floatValue
                            })
                          }
                          value={stock.costPrice}
                        />
                      </div>
                      {/* <div className="col-2">
                        <NumFormat
                          name="dealerPrice"
                          label="Dealer Price"
                          variant="outlined"
                          value={stock.itemMaster ? stock.itemMaster.dealerPrice : ""}
                          onChange={(e) => {
                            setStock({
                              ...stock,
                              itemMaster: {
                                ...stock.itemMaster,
                                dealerPrice: e.target.value,
                              },
                            });
                          }}
                        />
                      </div> */}
                      <div className="col-3">
                        <FormControl
                          name="wholesalePrice"
                          label="Wholesale Price"
                          control="currency"
                          onValueChange={(val) =>
                            setStock({
                              ...stock,
                              wholesalePrice: val.floatValue
                            })
                          }
                          value={stock.wholesalePrice}
                        />
                      </div>
                       <div className="col-3">
                        <FormControl
                          name="retailPrice"
                          label="Retail Price*"
                          control="currency"
                          onValueChange={(val) =>
                            setStock({
                              ...stock,
                              retailPrice: val.floatValue
                            })
                          }
                          value={stock.retailPrice}
                        />
                      </div>
                      <div className="col-3">
                        <NumFormat
                          name="discountPercentage"
                          label="Discount"
                          variant="outlined"
                          value={stock.discountPercentage}
                          onChange={handleStockDataChange}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">%</InputAdornment>
                            ),
                          }}
                        />
                      </div>
                     

                      {/* <div className="col-2">
                        <NumFormat
                          name="leastPrice"
                          label="Least Price"
                          variant="outlined"
                          value={stock.itemMaster ? stock.itemMaster.leastPrice : ""}
                          onChange={(e) => {
                            setStock({
                              ...stock,
                              itemMaster: {
                                ...stock.itemMaster,
                                leastPrice: e.target.value,
                              },
                            });
                          }}
                        />
                      </div> */}
                    </div>
                    <div className="row">
                      <div className="col-3">
                        <FormControl
                          name="discountAmount"
                          label="Discount Amount"
                          control="currency"
                          onValueChange={(val) =>
                            setStock({
                              ...stock,
                              discountAmount: val.floatValue
                            })
                          }
                          value={stock.discountAmount}
                        />
                      </div>
                      <div className="col-3">
                        <TextField
                          type="date"
                          label="Expiry Date"
                          name="expiryDate"
                          variant="outlined"
                          value={stock.expiryDate}
                          onChange={handleStockDataChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                          inputProps={{
                            min: today,
                          }}
                        />
                      </div>

                      <div className="col-3">
                        <NumFormat
                          name="warrantyPeriods"
                          label="Warranty Days"
                          variant="outlined"
                          value={stock.warrantyPeriods}
                          onChange={handleStockDataChange}
                        />
                      </div>
                      <div className="col-3">
                        <NumFormat
                          name="batch"
                          label="Batch Number"
                          variant="outlined"
                          value={stock.batch}
                          onValueChange={(val) =>
                            setStock({
                              ...stock,
                              batch: val.floatValue
                            })
                          }


                        />
                      </div>
                     

                     
                    </div>
                     <div className="row">
                       <div className="col-3">
                        Total:
                        {
                          currency(stock.costPrice * stock.quantity)
                        }<br />
                        Sub Total:
                        {
                          currency((stock.costPrice * stock.quantity) - ((stock.discountAmount * stock.quantity) + ((stock.costPrice * stock.quantity) * stock.discountPercentage / 100))
                          )}
                        {/* <TextField
                      hiddenLabel
                      id="filled-hidden-label-normal"
                      defaultValue="SUM :"
                      variant="filled"
                      control="currency"
                      autoComplete="true"
                      // value={(sum)}
                      const sum = {stock.costPrice * stock.quantity}
                      /> */}
                      </div>
                   
                        <div className="col-3">
                        <Button
                          className="generateBarcode"
                          onClick={() => handleSingleBarcodeGenerate(stock)}
                          startIcon={
                            barcodeLoading && (
                              <CircularProgress color="inherit" size={20} />
                            )
                          }
                          variant="contained"
                          color="primary"
                        >
                          Single Barcode
                        </Button>
                        <BasicDialog
                          open={openSingleBarcode}
                          setOpen={() => {
                            setOpenSingleBarcode(true);
                          }}
                          maxWidth="md"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>Barcode Single</div>
                            <div className="flex-end">
                              <Button
                                color="secondary"
                                onClick={() => {
                                  setOpenSingleBarcode(false);
                                }}
                              >
                                <CloseIcon />
                              </Button>
                            </div>
                          </div>
                          <BarcodePreview
                            products={products}
                            setOpenBarcode={setOpenSingleBarcode}
                            selectedDesign={labelSize}
                          />
                        </BasicDialog>
                        </div>
                        <div className="col-3">
                        <Button
                          className="generateBarcode"
                          onClick={() => handleMultipleBarcodeGenerate(values)}
                          startIcon={
                            barcodeLoading && (
                              <CircularProgress color="inherit" size={20} />
                            )
                          }
                          variant="contained"
                          color="primary"
                        >
                          Multiple Barcode
                        </Button>
                        <BasicDialog
                          open={openMultipleBarcode}
                          setOpen={() => {
                            setOpenMultipleBarcode(true);
                          }}
                          maxWidth="md"
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <div>Barcode Multiple</div>
                            <div className="flex-end">
                              <Button
                                color="secondary"
                                onClick={() => {
                                  setOpenMultipleBarcode(false);
                                }}
                              >
                                <CloseIcon />
                              </Button>
                            </div>
                          </div>
                          <BarcodePreview
                            products={products}
                            setOpenBarcode={setOpenMultipleBarcode}
                            selectedDesign={labelSize}
                          />
                        </BasicDialog>
                        </div>
                         <div className="col-3 flex-end">
                    
                      <RadioGroup
                        row
                        value={labelSize}
                        onChange={(e) => setLabelSize(e.target.value)}
                      >
                        <FormControlLabel
                          value="3by1"
                          control={<Radio />}
                          label="3 x 1"
                        />
                        <FormControlLabel
                          value="2by1"
                          control={<Radio />}
                          label="2 x 1"
                        />
                        <FormControlLabel
                          value="4by1"
                          control={<Radio />}
                          label="4 x 1 (A4)"
                        />
                      </RadioGroup>
                   

                      </div>
                      
                        
                      </div>

                   <div className="row flex-end mb">
                          <Button
                        onClick={() => {
                          if (stock.editIndex || stock.editIndex === 0) {

                            //here when we edit , call this one
                            remove(stock.editIndex);
                            push({
                              ...stock,
                              itemCode: stock.itemMaster.code,
                              //totalAmount: stock.costPrice * stock.quantity,

                              discountAmount: stock.discountAmount,
                              discountPercentage: stock.discountPercentage,
                              locationCode: defaultLocationSelected.location.code,
                              subTotalAmount: stock.costPrice * stock.quantity,
                              totalAmount: (stock.costPrice * stock.quantity) - ((stock.discountAmount * stock.quantity) + ((stock.costPrice * stock.quantity) * stock.discountPercentage / 100)),
                              discountTotal: (stock.discountAmount * stock.quantity) + ((stock.costPrice * stock.quantity) * (stock.discountPercentage / 100)),
                              sum: stock.costPrice * stock.quantity - ((stock.discountAmount * stock.quantity) + ((stock.costPrice * stock.quantity) * stock.discountPercentage / 100)),
                            });
                          } else {
                            const existingItemIndex = stockHistories.findIndex(item => item.itemMaster.code === stock.itemMaster.code);
                            if (existingItemIndex !== -1) {
                              // If an item with the same code exists, update its quantity
                              let newQuantity = parseFloat(stockHistories[existingItemIndex].quantity) + parseFloat(stock.quantity);
                              stockHistories[existingItemIndex].quantity = newQuantity;
                              stockHistories[existingItemIndex].discountAmount = stock.discountAmount;
                              stockHistories[existingItemIndex].discountPercentage = stock.atdiscountPercentage;
                              stockHistories[existingItemIndex].subTotalAmount = stock.costPrice * newQuantity;
                              stockHistories[existingItemIndex].totalAmount = (stock.costPrice * newQuantity) - ((stock.discountAmount * newQuantity) + ((stock.costPrice * newQuantity) * stock.discountPercentage / 100));
                              stockHistories[existingItemIndex].discountTotal = (stock.discountAmount * newQuantity) + ((stock.costPrice * newQuantity) * (stock.discountPercentage / 100));
                              stockHistories[existingItemIndex].sum = stock.costPrice * newQuantity - ((stock.discountAmount * newQuantity) + ((stock.costPrice * newQuantity) * stock.discountPercentage / 100));
                              stockHistories[existingItemIndex].wholesalePrice = stock.wholesalePrice;
                              stockHistories[existingItemIndex].retailPrice = stock.retailPrice;
                              stockHistories[existingItemIndex].costPrice = stock.costPrice;

                            } else {
                              push({
                                ...stock,
                                itemCode: stock.itemMaster.code,
                                //totalAmount: stock.costPrice * stock.quantity,

                                discountAmount: stock.discountAmount,
                                discountPercentage: stock.discountPercentage,
                                locationCode: defaultLocationSelected.location.code,
                                subTotalAmount: stock.costPrice * stock.quantity,
                                totalAmount: (stock.costPrice * stock.quantity) - ((stock.discountAmount * stock.quantity) + ((stock.costPrice * stock.quantity) * stock.discountPercentage / 100)),
                                discountTotal: (stock.discountAmount * stock.quantity) + ((stock.costPrice * stock.quantity) * (stock.discountPercentage / 100)),
                                sum: stock.costPrice * stock.quantity - ((stock.discountAmount * stock.quantity) + ((stock.costPrice * stock.quantity) * stock.discountPercentage / 100)),
                              });
                            }
                          }
                          setStock(initStockValue);
                        }}
                        variant="contained"
                        disabled={
                          !stock.itemMaster ||
                          // stock.locationCode === "" ||
                          stock.quantity === "" ||
                          (stock.quantity == 0 && !code) ||
                          !stock.costPrice ||
                          !stock.retailPrice
                        }
                      >
                        {stock.editIndex || stock.editIndex === 0
                          ? "Update"
                          : "Add"}
                      </Button>
                        </div>
                    <div className="row">
                      <Table
                        setStock={setStock}
                        data={stockHistories}
                        setFieldValue={setFieldValue}
                        remove={remove}
                        code={code}
                        grnValue={grnValue}
                        setGrnValue={setGrnValue}
                      />
                    </div>
                  </>
                );
              }}
            </FieldArray>
          </>
        );

      default:
        return null;
    }
  }
};

export default AddGRN;